import server from 'common/utils/server';
import { parseQueryString } from 'common/utils/queryStringUtils';
import { reduce } from 'lodash';

export const getAllColumns = state =>
  Object.keys(state.companyTrendsReportsState.cachedResponses).flatMap(
    key => state.companyTrendsReportsState.cachedResponses[key].cols
  );

export const companyTrendsReportsState = (
  state = {
    tabs: [],
    cachedResponses: {},
    tableRowsById: {},
    tableRows: [],
  },
  action
) => {
  switch (action.type) {
    case 'SET_TABLE_TABS': {
      const { tabs } = action;
      return {
        ...state,
        tabs,
      };
    }
    case 'SET_CACHED_FLEX_REQUEST': {
      const { urlKey, response } = action;
      const { rows, cols } = response;

      const newTableRowsById = { ...state.tableRowsById };
      Object.keys(rows).forEach(employeeId => {
        const existingRow = state.tableRowsById[employeeId]
          ? { ...state.tableRowsById[employeeId] }
          : { profileKey: employeeId };
        const rowWithPrefixedKeys = reduce(
          rows[employeeId],
          (result, value, key) => {
            result[`${urlKey};${key}`] = value;
            return result;
          },
          {}
        );

        newTableRowsById[employeeId] = {
          ...existingRow,
          ...rowWithPrefixedKeys,
        };
      });

      const columnsWithPrefixedKeys = cols.map(column => ({
        ...column,
        key: `${urlKey};${column.key}`,
      }));

      return {
        ...state,
        cachedResponses: {
          ...state.cachedResponses,
          [urlKey]: {
            ...state.cachedResponses[urlKey],
            cols: columnsWithPrefixedKeys,
          },
        },
        tableRowsById: newTableRowsById,
        tableRows: Object.values(newTableRowsById),
      };
    }
    case 'START_CACHED_FLEX_REQUEST': {
      const { urlKey } = action;
      const defaultCachedResponseState = { cols: [], loading: true };
      return {
        ...state,
        cachedResponses: {
          ...state.cachedResponses,
          [urlKey]: defaultCachedResponseState,
        },
      };
    }
    case 'FINISH_CACHED_FLEX_REQUEST': {
      const { urlKey } = action;
      return {
        ...state,
        cachedResponses: {
          ...state.cachedResponses,
          [urlKey]: { ...state.cachedResponses[urlKey], loading: false },
        },
      };
    }
    case 'CLEAR_CACHED_FLEX_REQUESTS': {
      return {
        ...state,
        cachedResponses: {},
        tableRowsById: {},
        tableRows: [],
      };
    }

    default: {
      return state;
    }
  }
};

export const fetchTabData = (url, resourceName, search) => dispatch => {
  const queryParams = {
    ...parseQueryString(search),
    aggregate_by: resourceName === 'teams' ? 'team_owners' : 'team_members',
  };
  queryParams.solicitation_reporting_timestamp = queryParams.solicitationReportingTimestamp?.toLowerCase();
  
  const urlKey = url; // 'url;search' to cache filters
  dispatch({ type: 'START_CACHED_FLEX_REQUEST', urlKey });

  const body = JSON.stringify(queryParams);
  return server
    .post(url, body)
    .then(response => {
      dispatch({ type: 'SET_CACHED_FLEX_REQUEST', urlKey, response });
    })
    .finally(() => {
      dispatch({ type: 'FINISH_CACHED_FLEX_REQUEST', urlKey });
    });
};

export const fetchTableTabs = () => dispatch =>
  server.get('/api/v2/team_reports/tabs').then(response => {
    dispatch({ type: 'SET_TABLE_TABS', tabs: response.tabs });
  });

export const clearCachedFlexRequests = () => dispatch => {
  dispatch({ type: 'CLEAR_CACHED_FLEX_REQUESTS' });
};
